import { decodeSafeEntities } from '@/lib/sanitise-strings'
import Link from 'next/link'

import getTermUrl from '@/lib/get-taxonomy-url'
import { Fragment } from 'react'

export default function TermLinks({
  heading,
  terms,
  postType,
  classNames = {},
}: {
  heading?: string
  postType?: string
  terms: {
    id: number
    name: string
    slug: string
    description: string
    taxonomy: string
    link: string
    icon_image: string | null
  }[]
  classNames?: {
    wrapper?: string
    item?: string
  }
}) {
  const {
    wrapper: wrapperClassNames = 'mt-xxs flex flex-wrap gap-xxs',
    item: itemClassNames = 'rounded-sm bg-theme-alt px-xxs py-[2px] leading-normal text-[length:--p-xs-size] hover:bg-black hover:text-white transition-colors duration-500',
  } = classNames || {}

  if (!terms.length) {
    return null
  }

  return (
    <>
      {heading ? <h6 className="h6">{heading}</h6> : null}

      <div className={wrapperClassNames}>
        {terms.map((term, index) => {
          const termUrl = getTermUrl(term, postType)

          return (
            <Fragment key={index}>
              {termUrl ? (
                <Link href={termUrl} className={itemClassNames}>
                  {decodeSafeEntities(term.name)}
                </Link>
              ) : (
                <span className={itemClassNames}>{decodeSafeEntities(term.name)}</span>
              )}
            </Fragment>
          )
        })}
      </div>
    </>
  )
}
